export const UPDATE_TOP_STORES_WIDGET = "UPDATE_TOP_STORES_WIDGET";